module.exports = __webpack_public_path__ + "img/IMG-20200723-WA0002.92df7be3.jpg";